import { $ } from "../third-party-imports";

export function updateSearchTermOnBlog()
{
    if (localStorage.getItem('searchTerm') !== undefined)
    {
        $('.newsletter_sec .propertForm').find('input').val(localStorage.getItem('searchTerm'));
    }
}
